import { FormLayout } from '@careinfo/layout';
import { useForm } from 'react-hook-form';
import TextField from '../Reusable/TextInput';
import { tw } from '@careinfo/tailwind';
import UnControlSwitch from '../Reusable/UnControlSwitch';
import { ISettingData } from '../../types/interfaces';
import ComboboxInput from '../Reusable/ComboboxInput';
import APIS from '../../constant/EndPoint';

const Setting = (props: any) => {
  const { handleUpdate, isLoading, slug, data, handleToggleActive } = props;
  const {
    handleSubmit,
    setError,
    setValue,
    register,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm<ISettingData>({
    defaultValues: async () => {
      return {
        comment_webhook: data?.comment_webhook,
        status_webhook: data?.status_webhook,
        merchant_id: data?.merchant_id,
        data: {
          token: data?.data?.token,
          endpoint: data?.data?.endpoint,
          schema_name: data?.data?.schema_name,
        },
      };
    },
  });

  return (
    <div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleUpdate}
        setError={setError}
        buttonLabel={'Update'}
        isLoading={isLoading}
      >
        <div className={tw`flex gap-x-2 items-center mt-2 px-4`}>
          <label htmlFor=''>Active</label>
          <UnControlSwitch
            value={data?.is_active}
            onChange={handleToggleActive}
          />
        </div>
        <div className={tw`grid grid-cols-2 gap-x-4 px-4`}>
          <TextField
            label={'End Point'}
            register={register('data.endpoint')}
            errors={errors?.data?.endpoint}
          />
          <TextField
            label={'Token'}
            register={register('data.token')}
            errors={errors?.data?.token}
          />
          <TextField
            label={'Status Webhook'}
            register={register('status_webhook')}
            errors={errors?.status_webhook}
          />
          <TextField
            label={'Comment Webhook'}
            register={register('comment_webhook')}
            errors={errors?.comment_webhook}
          />
          <TextField
            label={'Schema Name'}
            register={register('data.schema_name')}
            errors={errors?.data?.schema_name}
          />
          <TextField
            label={'Merchant Id'}
            register={register('merchant_id')}
            errors={errors?.merchant_id}
          />
        </div>
      </FormLayout>
    </div>
  );
};
export default Setting;
